import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}`;
const SignatureDocuments_API_URL = `${API_URL}/SignatureDocuments`;

// Get all signature documents by case ID
const GetByCaseId = async (caseId, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/GetByCaseId/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
    });
    return response;
};

// Get signature document by ID
const GetById = async (id, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/GetById/${id}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
    });
    return response;
};

// Get unsigned documents
const GetUnsigned = async (caseId, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/GetUnsigned/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
    });
    return response;
};

// Get unsigned count
const GetUnsignedCount = async (caseId, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/GetUnsignedCount/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
    });
    return response;
};

// Create new signature document
const CreateSignatureDocument = async (formData, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
        body: formData,
    });
    return response;
};

// Update signature document
const UpdateSignatureDocument = async (data, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/Update`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    return response;
};

// Set signature position
const SetSignaturePosition = async (data, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/SetSignaturePosition`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    return response;
};

// Sign document
const SignDocument = async (data, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/Sign`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    return response;
};

// Delete signature document
const DeleteSignatureDocument = async (id, auth) => {
    const response = await fetch(`${SignatureDocuments_API_URL}/Delete/${id}`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
    });
    return response;
};

const SignatureDocumentService = {
    GetByCaseId,
    GetById,
    GetUnsigned,
    GetUnsignedCount,
    CreateSignatureDocument,
    UpdateSignatureDocument,
    SetSignaturePosition,
    SignDocument,
    DeleteSignatureDocument
};

export default SignatureDocumentService;

